<template lang="pug">
modal-window.modal-notification-edit(:title='title', :overflowVisible='true', ref='modalWindow')
  .modal-notification-edit__inner(v-if='notificationEditData')
    .modal-notification-edit__inner__body(ref='modalBody')
      .modal-notification-edit__inner__body__error
        .modal-notification-edit__inner__body__error__message.text-small(v-for='message in errorMessages') {{ message }}
      .modal-notification-edit__inner__body__item
        .modal-notification-edit__inner__body__item__label.text-small
          slot(name='titleLabel')
        textbox-setting.modal-notification-edit__inner__body__item__input(
          v-model='notificationEditData.title',
          :placeholder='titlePlaceholder'
        )
      .modal-notification-edit__inner__body__item
        .modal-notification-edit__inner__body__item__label.text-small
          slot(name='startDateLabel')
        date-picker-single.modal-notification-edit__inner__body__item__input(
          v-model='notificationEditData.startDate',
          :placeholder='startDatePlaceholder'
        )
      .modal-notification-edit__inner__body__item
        .modal-notification-edit__inner__body__item__label.text-small
          slot(name='endDateLabel')
        date-picker-single.modal-notification-edit__inner__body__item__input(
          v-model='notificationEditData.endDate',
          :placeholder='endDatePlaceholder'
        )
      .modal-notification-edit__inner__body__item
        .modal-notification-edit__inner__body__item__label.text-small
          slot(name='messageLabel')
        text-editor-setting.modal-notification-edit__inner__body__item__input(
          v-model='notificationEditData.message',
          :placeholder='messagePlaceholder'
        )
    .modal-notification-edit__inner__footer
      button-modal-keep.modal-notification-edit__inner__footer__button(@click='keep')
        slot(name='keepText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/manager/ModalWindow.vue'
import TextboxSetting from '@/components/molecules/manager/TextboxSetting.vue'
import DatePickerSingle from '@/components/molecules/manager/DatePickerSingle.vue'
import TextEditorSetting from '@/components/molecules/manager/TextEditorSetting.vue'
import ButtonModalKeep from '@/components/molecules/manager/ButtonModalKeep.vue'
import { NotificationEditType } from '@/models/notificationModel'

/**
 * お知らせ管理編集モーダル
 */
@Component({
  components: {
    ModalWindow,
    TextboxSetting,
    DatePickerSingle,
    TextEditorSetting,
    ButtonModalKeep,
  },
})
export default class ModalNotificationEdit extends Vue {
  // モーダルのタイトル
  @Prop()
  title!: string

  // 編集対象のお知らせ情報
  @Prop()
  notificationEditData?: NotificationEditType

  // 件名プレースホルダー
  @Prop()
  titlePlaceholder!: string

  // 表示開始日時プレースホルダー
  @Prop()
  startDatePlaceholder!: string

  // 表示終了日時プレースホルダー
  @Prop()
  endDatePlaceholder!: string

  // 本文プレースホルダー
  @Prop()
  messagePlaceholder!: string

  // 保存ボタン押下時イベント
  @Prop()
  keepButtonEvent!: Function

  // エラーメッセージ
  @Prop()
  errorMessages!: string[]

  // モーダルウィンドウのRef
  @Ref()
  modalWindow!: ModalWindow

  // 入力エリア部のHTLMエレメント
  @Ref()
  modalBody!: HTMLElement

  // 保存処理
  private async keep() {
    await this.keepButtonEvent()
    if (this.errorMessages.length > 0) {
      // エラーメッセージがある場合は入力エリア部のトップまでスクロール
      this.modalBody.scrollTo({ top: 0 })
    } else {
      this.modalWindow.hide()
    }
  }

  public show() {
    this.modalWindow.show()
  }
}
</script>

<style lang="stylus" scoped>
.modal-notification-edit
  &__inner
    display flex
    height 463px
    flex-direction column
    align-items flex-start
    gap 20px

    &__body
      display flex
      flex-direction column
      gap 12px
      overflow-y auto

      &__error
        &__message
          color var(--color-manager-modal-alert__text)

      &__item
        width 100%
        display flex
        flex-direction column
        gap 12px

    &__footer
      margin-top auto
</style>
